import React, { useEffect, useRef, useState } from "react";
import { Accordion, Alert, Button, Col, Form, Row } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import $ from "jquery";

import { useSubheader } from "../../../../_metronic/layout";
import { update, getBySlug } from "../../services/hospitalizationcrud";
import { isEmpty } from "../../../_utils/checkObjectEmpty";

import CaseHeader from "../../subPages/CaseHeader/CaseHeader";
import { InssuredData } from "../../subPages/InsuredData/InssuredData";
import { HospitalData } from "../../subPages/HospitalData/HospitalData";
import { FamilyData } from "../../subPages/FamilyData/FamilyData";
import { MedicAssigned } from "../../subPages/MedicAssigned/MedicAssigned";
import { Documentation } from "../../subPages/Documentation/Documentation";
import { Binnacle } from "../../subPages/Binnacle/Binnacle";
import SimpleModal from "../../../components/SimpleModal";

import BlockCaseContext from "../../../contexts/BlockCaseContext";
import IncomeTypeContext from "../../../contexts/IncomeTypeContext";

const AttentionCenterZurichDetails = (props) => {
  const subheader = useSubheader();
  subheader.setTitle("Centro de Atención Zurich");

  const { slug } = props.match.params;
  const [caseRecord, setCaseRecord] = useState({});
  const [shouldBlockCase, setShouldBlockCase] = useState(true);
  const [incomeType, setIncomeType] = useState("");
  const [folioIh, setFolioIh] = useState("");
  const [savingFolioIh, setSavingFolioIh] = useState(false);
  const [notice, setNotice] = useState(null);
  const folioIhInputRef = useRef(null);
  const history = useHistory();

  let submitFormInssuredData = null;
  let submitFormInssuredDataErrors = null;

  const bindSubmitFormInssuredData = (submitForm) =>
    (submitFormInssuredData = submitForm);

  const bindSubmitFormInssuredDataErrors = (errors) =>
    (submitFormInssuredDataErrors = errors);

  const showNotice = (message, guideToFolioIh = false) =>
    setNotice({ message, guideToFolioIh });

  const closeNotice = () => {
    const shouldGuideToFolioIh = notice?.guideToFolioIh;
    setNotice(null);

    if (!shouldGuideToFolioIh) return;

    window.requestAnimationFrame(() => {
      const input = folioIhInputRef.current;
      if (!input) return;

      const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      input.scrollIntoView({
        behavior: reduceMotion ? "auto" : "smooth",
        block: "center",
      });
      input.focus({ preventScroll: true });

      if (!reduceMotion) {
        input.animate(
          [
            { transform: "translateY(0)" },
            { transform: "translateY(-6px)" },
            { transform: "translateY(0)" },
            { transform: "translateY(-3px)" },
            { transform: "translateY(0)" },
          ],
          {
            duration: 260,
            easing: "cubic-bezier(0.23, 1, 0.32, 1)",
          }
        );
      }
    });
  };

  const getCaseBySlug = () =>
    getBySlug(slug).then((response) => setCaseRecord(response.data));

  useEffect(() => {
    window.wasCommented = false;
    getCaseBySlug();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (caseRecord?.incomeType) setIncomeType(caseRecord.incomeType);
    if (caseRecord?.folioIh) setFolioIh(caseRecord.folioIh);
  }, [caseRecord]);

  const onSaveFolioIH = async () => {
    const normalizedFolioIh = String(folioIh || "").trim();
    if (!normalizedFolioIh) {
      showNotice("No capturó el Folio IH. Captúrelo para avanzar.", true);
      return;
    }
    setSavingFolioIh(true);
    try {
      await update({ ...caseRecord, folioIh: normalizedFolioIh }, caseRecord.id);
      setFolioIh(normalizedFolioIh);
      setCaseRecord({ ...caseRecord, folioIh: normalizedFolioIh });
    } catch (e) {
      showNotice("No se pudo guardar el Folio IH. Intente nuevamente.", true);
    } finally {
      setSavingFolioIh(false);
    }
  };

  const onClickSendControlDesk = async () => {
    let dataForms = {};
    for (const formId of ["formu1", "formu2", "formu3", "formu4"]) {
      const formEl = document.getElementById(formId);
      if (!formEl) continue;
      for (const pair of new FormData(formEl).entries()) {
        dataForms[pair[0]] = pair[1];
      }
    }

    await submitFormInssuredData();
    if (!isEmpty(submitFormInssuredDataErrors)) {
      showNotice("Debe completar correctamente los campos obligatorios de Datos Asegurado.");
      return;
    }

    const pendingFolioIh = String(folioIh || "").trim();
    const savedFolioIh = String(caseRecord.folioIh || "").trim();
    const finalFolioIh = pendingFolioIh || savedFolioIh;

    if (!finalFolioIh) {
      showNotice("No capturó el Folio IH. Captúrelo para avanzar.", true);
      return;
    }

    if (!window.wasCommented) {
      showNotice("Debe ingresar un comentario en la Bitácora antes de avanzar el caso.");
      return;
    }

    if (pendingFolioIh && pendingFolioIh !== savedFolioIh) {
      setSavingFolioIh(true);
      try {
        await update({ ...caseRecord, folioIh: pendingFolioIh }, caseRecord.id);
        setCaseRecord({ ...caseRecord, folioIh: pendingFolioIh });
      } catch (e) {
        showNotice("No se pudo guardar el Folio IH. Intente nuevamente.", true);
        return;
      } finally {
        setSavingFolioIh(false);
      }
    }

    const timestamp = await axios.get("/cases/getTimestamp");
    const merged = {
      ...caseRecord,
      ...dataForms,
      folioIh: finalFolioIh,
      caseStatusId: 2,
      feamesaControl: moment.utc(timestamp.data).format(),
    };

    $("#btn_save_comment").click();
    update(merged, caseRecord.id).then(() => {
      history.push("/centro_atencion_zurich");
    });
  };

  return (
    <>
      <Alert
        variant="success"
        className="text-center"
        style={{ fontSize: "16px" }}
      >
        Centro de Atención Zurich
      </Alert>

      <CaseHeader
        caseRecord={caseRecord}
        hideComprehensiveCare={true}
        hideRequiresTabulation={true}
        hideHospitalModel={true}
        showFolioEp={true}
        showPolicy={true}
        folioIhSlot={
          caseRecord.folioIh ? (
            <>
              <b>Folio IH: </b>
              {caseRecord.folioIh}
              <br />
            </>
          ) : (
            <>
              <b>Folio IH: </b>
              <div style={{ display: "inline-flex", alignItems: "center", gap: "8px" }}>
                <Form.Control
                  ref={folioIhInputRef}
                  type="text"
                  placeholder="Ingrese Folio IH"
                  value={folioIh}
                  onChange={(e) => setFolioIh(e.target.value)}
                  style={{ width: "200px", display: "inline-block" }}
                  size="sm"
                />
                <Button
                  size="sm"
                  variant="primary"
                  onClick={onSaveFolioIH}
                  disabled={savingFolioIh}
                >
                  {savingFolioIh ? "Guardando..." : "Guardar"}
                </Button>
              </div>
              <br />
            </>
          )
        }
      />

      <BlockCaseContext.Provider value={[shouldBlockCase, setShouldBlockCase]}>
      <IncomeTypeContext.Provider value={[incomeType, setIncomeType]}>
        <Accordion defaultActiveKey="0" className="mt-5">
          <HospitalData
            icon="fa-search"
            eventKey="0"
            data={caseRecord}
            disabledAll={true}
            bindSubmitForm={() => {}}
          />
          <InssuredData
            icon="fa-search"
            eventKey="1"
            data={caseRecord}
            disabledAll={false}
            bindSubmitForm={bindSubmitFormInssuredData}
            bindErrors={bindSubmitFormInssuredDataErrors}
          />
          <FamilyData
            icon="fa-search"
            eventKey="2"
            data={caseRecord}
            disabledAll={true}
            bindSubmitForm={() => {}}
          />
          <MedicAssigned
            icon="fa-search"
            eventKey="3"
            data={caseRecord}
            disabledAll={true}
            bindSubmitForm={() => {}}
          />
          {!isEmpty(caseRecord) && (
            <Documentation icon="fa-search" eventKey="4" data={caseRecord} slug={caseRecord.slug} allowSelectiveDownload={true} />
          )}
          {!isEmpty(caseRecord) && (
            <Binnacle
              icon="fa-pencil-alt"
              eventKey="5"
              data={caseRecord}
              slug={caseRecord.slug}
              eventStage="Centro de Atención Zurich"
            />
          )}
        </Accordion>
      </IncomeTypeContext.Provider>
      </BlockCaseContext.Provider>

      <Row className="mt-5" style={{ justifyContent: "flex-end" }}>
        <Col xs="auto">
          <Button variant="primary" onClick={onClickSendControlDesk}>
            Enviar a Mesa de Control
          </Button>
        </Col>
      </Row>

      <SimpleModal
        open={Boolean(notice)}
        title="Atención"
        message={notice?.message || ""}
        onConfirm={closeNotice}
        confirmLabel="Entendido"
      />
    </>
  );
};

export default AttentionCenterZurichDetails;
